import {Component, OnInit} from '@angular/core';
import {CardsContent} from "../news/news.component";
import {TranslateService} from "../../../services/translate.service";
import {AhmService} from "../../../services/ahm.service";

@Component({
    selector: 'app-instruments',
    templateUrl: './instruments.component.html',
    styleUrls: ['./instruments.component.css']
})
export class InstrumentsComponent implements OnInit {


    allInstrumentsEng: CardsContent [] = [
        {
            title: '',
            date: '',
            alink: '',
            avatar: '',
            images: [],
            text: [
                'The most important tool is the understanding of the AHM classification and skills, which are based on this classification. Nevertheless, there are already tools that greatly simplify many aspects or increase accuracy, efficiency, impact force, etc. The more practice the better.'
            ],
            links: []
        },
        {
            title: 'AHM Assistant',
            date: '',
            alink: '#helper',
            avatar: '../../../../assets/images/instruments/helper.png',
            images: [],
            text: [
                '',
                'AHM, not an ordinary book.',
                'One of the points. Every AHM Reader noticed. Too many shortcuts.',
                'The new era of psychology needs it. But missing one while reading and understanding lost.',
                'Now you can simply print it here and get meaning.'
            ],
            links: []
        },
        {
            title: 'Mental flowchart editor',
            date: '',
            alink: '/psymodeler',
            avatar: '../../../../assets/images/buttons/psymodeler1.png',
            images: [],
            text: [
                '',
                'Or PSY-Modeler (Desktop).',
                'The first flowchart in the history of psychology, which represented the psycho-types of people and / or group / team. As well as the flows of aggression, as the main symptom and other symptoms was presented by the authors of the AHM.',
                'In the book AHM2 there is a specification for the construction of mental or aggressive flowcharts. Many newcomers to AHM have already heard a lot, that any psychoanalysis must begin with the most accurate definition of psycho-types for the participants of the event.',
                'Otherwise, this type of psychoanalysis cannot even be considered unsatisfactory. Because the same events for different types of personality cause different and opposite processes in the psyche...',
                'The psychic flowchart takes the understanding of the processes in the psyche to a new level. And how do these processes affect the psyche of other psycho-types.',
                'In developing...'
            ],
            links: []
        },
        {
            title: 'Tests',
            date: '',
            alink: '',
            avatar: '../../../../assets/images/button_tt_color_1339.png',
            images: [],
            text: [
                '',
                'The complex of automatic and semi-automatic tests. Which help to better determine the psycho-types of participants in an event or group. Others and personal. Increase the accuracy of psychoanalysis. Personal (self-examination) and others.',
                'In developing...'
            ],
            links: []
        },
        {
            title: 'AHM Events',
            date: '',
            alink: '',
            avatar: '../../../../assets/images/events/psyin3sec/title_img_1339.jpg',
            images: [],
            text: [
                '',
                'AHM events are not only interesting. But also very much help to up/improve your skills. An event such as "Psycho Type In 3 Seconds", for example, is a very good workout in the form of a game for FBI officers.',
                'They need to know the type of personality of a potential criminal for the minimum time. Sometimes, it only has 3 seconds. And this is the real situation.',
                'For the store manager, this game is also very useful in order to determine the psycho type of the buyer as soon as possible and send him the best of the psycho types of employees.',
                'This will help avoid the conflict of psychtypes and other types of conflicts, and thus increase the chance of success purchase and profit of the store.',
                'For events there is a separate section in the site menu.'
            ],
            links: []
        }
    ];

    allInstrumentsRus: CardsContent [] = [
        {
            title: '',
            date: '',
            alink: '', avatar: '',
            images: [],
            text: [
                'Самый важный инструмент - это понимание классификации АЧП и умения, которые базируются на этой классификации. Тем не менее уже существуют инструменты, которые сильно упрощают многие моменты или увеличивают точность, эффективность, силу воздействия и т.п. Чем больше практики, тем лучше.'
            ],
            links: []
        },
        {
            title: 'АЧП Ассистент',
            date: '',
            alink: '#helper',
            avatar: '../../../../assets/images/instruments/helper.png',
            images: [],
            text: [
                '',
                'АЧП, не обычная книга.',
                'Один из пунктов. Каждый читатель АЧП заметил. Слишком много сокращений.',
                'Новая эра психологии нуждается в этом. Но пропустить одно во время чтения и понимание потеряно.',
                'Теперь вы можете просто напечатать сокращение здесь и получить значение.'
            ],
            links: []
        },
        {
            title: 'Редактор психических блок-схем',
            date: '',
            alink: '/psymodeler',
            avatar: '../../../../assets/images/buttons/psymodeler1.png',
            images: [],
            text: [
                '',
                'PSY-Modeler (Desktop)',
                'Первую блок-схему в истории психологии, на которой были представлены психотипы людей и/или группы/коллектива. А также потоки агрессии, как основной симптом и других симптомов представили авторы АПЧ.',
                'В книге АЧП2 есть спецификация по построению психических или агрессивных блок-схем. Многие новички АЧП уже много слышали, что любой психоанализ должен начинаться с максимально точного определения психотипов для участников данного события.',
                'Иначе данный вид психоанализа не может считаться даже удовлетворительным. Т.к. одинаковые события для разных типов личности вызывают разны и противоположные процессы в психике...',
                'Психическая блок-схема переводит понимание процессов в психике на новый уровень. И как эти процессы влияют на психику других психотипов.',
                'В разработке...'
            ],
            links: []
        },
        {
            title: 'Тесты',
            date: '',
            alink: '', avatar: '../../../../assets/images/button_tt_color_1339.png',
            images: [],
            text: [
                '',
                'Комплекс автоматических и полуавтоматических тестов. Которые помогают лучше определить психотипы участников события или группы. Окружающих и свой личный. Увеличивают точность психоанализа. Личного (самоанализ) и окружаюущих.',
                'В разработке...'
            ],
            links: []
        },
        {
            title: 'События АЧП',
            date: '',
            alink: '', avatar: '../../../../assets/images/events/psyin3sec/title_img_1339.jpg',
            images: [],
            text: [
                '',
                'События АЧП не только инетресны. Но и очень сильно помогают прокачать/улучшить свои навыки/скиллы. Такое событие, как "Психотип За 3 секунды", к примеру, очень хорошая тренировки в игровой форме для сотрудников ФСБ.',
                'Им надо знать тип личности потенциального преступника за минимальное время. Иногда, на это есть всего 3 секунды. И это реальная ситуация.',
                'Для менеджера магазина также эта игра очень полезна чтобы как можно скорее определить психотип покупателя и отправить к нему лучший из психотипов сотрудников.',
                'Это поможет избежать конфликта психтипов и других конфликтов при покупки, а значит увеличит шанс успеха и прибыль магазина.',
                'Для событий выделена отдельная секция в меню сайта.'
            ],
            links: []
        }
    ];

    constructor(private translate: TranslateService, private service: AhmService) {
    }

    ngOnInit() {
    }

    goLink(link: string) {
        setTimeout(() => {
            window.open(link, '_blank');
        }, 300);
    }

    openLink(alink: string) {
        let finLink = alink.replace('#', '');
        if ('helper' === finLink) {
            this.service.helperContentBlock();
        }
    }
}
